import { Injectable } from '@angular/core';
import {FirestoreService} from "../../services/firestore.service";

@Injectable({
  providedIn: 'root'
})
export class CurdService {

  constructor(private firestoreService: FirestoreService) { }

  index(collection_name: string) {
    return this.firestoreService.colWithIds$(collection_name);
  }

  query(collection_name: string, query: any) {
    return this.firestoreService.colWithIds$(collection_name, query);
  }

  store(collection_name: string, data: any) {
    return this.firestoreService.add(collection_name, data);
  }

  show(collection_name: string, document_id: any) {
    return this.firestoreService.doc(`${collection_name}/${document_id}`);
  }

  showRealTime(collection_name: string, document_id: any) {
    return this.firestoreService.doc$(`${collection_name}/${document_id}`);
  }

  update(collection_name: string, document_id: string, data: any) {
    return this.firestoreService.update(`${collection_name}/${document_id}`, data)
  }

  delete(collection_name: string, document_id: string) {
    return this.firestoreService.delete(`${collection_name}/${document_id}`);
  }

  // tslint:disable-next-line:typedef
  setWithID(collection_name: string, data: any) {
    return new Promise<any>((resolve, reject) => {
      this.firestoreService.set(collection_name, data)
        .then(
          (res: any) => resolve(res),
          (err: any) => reject(err)
          )

    });
  }


  uploadImage(image: string, file_name: string, path: string, is_default: boolean = false) {
    return this.firestoreService.uploadImage(image, file_name, path, is_default);
  }

}
